const login = () =>
  import(/* webpackChunkName: "login" */ "@/views/ahouse/login/login");

const redemption = () =>
  import(/* webpackChunkName: "redemption" */ "@/views/ahouse/redemption");

const detail = () =>
  import(
    /* webpackChunkName: "redemption" */ "@/views/ahouse/redemption/detail"
  );

const record = () =>
  import(/* webpackChunkName: "redemption" */ "@/views/ahouse/user/record");

const info = () =>
  import(/* webpackChunkName: "redemption" */ "@/views/ahouse/setting/info");

const forget = () =>
  import(/* webpackChunkName: "forget" */ "@/views/ahouse/login/forget");

const success = () =>
  import(/* webpackChunkName: "success" */ "@/views/ahouse/login/forget/success");

export default [
  {
    path: "/ahouse/login",
    name: "ahouse-login",
    meta: { title: "A House 登录" },
    component: login
  },
  {
    path: "/ahouse/setting/info",
    name: "ahouse-setting-info",
    meta: { title: "个人信息" },
    component: info
  },
  {
    path: "/ahouse/redemption",
    name: "ahouse-redemption",
    meta: { title: "兑换" },
    component: redemption
  },
  {
    path: "/ahouse/redemption/detail",
    name: "ahouse-redemption-detail",
    meta: { title: "兑换详情" },
    component: detail
  },
  {
    path: "/ahouse/user/record",
    name: "ahouse-user-record",
    meta: { title: "兑换记录" },
    component: record
  },
  {
    path: "/ahouse/login/forget",
    name: "ahouse-login-forget",
    meta: { title: "忘记密码" },
    component: forget
  },
  {
    path: "/ahouse/success",
    name: "ahouse-success",
    meta: { title: "操作成功" },
    component: success
  }
];
